export default __webpack_public_path__ + "static/media/pic6.324dc399.png";